import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Link,
  Paper,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';

import ColorModeIconDropdown from '../../themes/MuiTheme/ColorModeIconDropdown';
import { createAccount } from '../../api/auth';

export default function ProcessOrderForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const order = location.state?.order;

  const theme = useTheme();

  const { signIn, signInWithGoogle, signInWithFacebook } = useAuth();
  const [loading, setLoading] = useState(false);
  const [displayAccountData, setDisplayAccountData] = useState(false);

  const [agree, setAgree] = useState(false);

  const formData = useRef({ email: '', password: '', rememberMe: false });

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      const { email, password, lastName, firstName } = formData.current;
      console.log('formData', email, password, lastName, firstName);
      const userData = { lastName, firstName, email, password };
      setLoading(true);

      const result = await createAccount(userData);

      const res2 = await signIn({ email, password });
      if (res2.isOk) {
        setLoading(false);
      }
    },
    [signIn]
  );

  if (!order) {
    navigate('/');
  }

  const openCreateAccount = () => {
    setDisplayAccountData(true);
  };

  return (
    <Paper
      elevation={3}
      variant='main'
      sx={{
        display: 'flex', // Flexbox engedélyezése
        flexDirection: 'column', // Oszlopirányba rendezi az elemeket
        alignItems: 'center',
        padding: 3,
        maxWidth: 1400,
        margin: '2% auto',
      }}
    >
      <div style={{ position: 'fixed', top: 30, right: 30 }}>
        <ColorModeIconDropdown size='medium' />
      </div>
      <Typography variant='subtitle1' textAlign='center' sx={{ mb: 2 }}>
        {order.price_details}
      </Typography>
      <Typography
        sx={{
          fontSize: '1.2rem',
          textAlign: 'center',
          color: theme.palette.primary.highlight,
        }}
        dangerouslySetInnerHTML={{ __html: order.price_highlight }}
      />
      <Typography variant='subtitle1' textAlign='center' sx={{ mb: 2 }}>
        A folytatáshoz egy fiókot kell létrehoznod nálunk az alábbi lehetőségek
        valamelyikével.
      </Typography>
      <FormControlLabel
        control={<Checkbox checked={agree} onChange={() => setAgree(!agree)} />}
        label={
          <Typography variant='body2'>
            A tagság létrehozásával az <Link to='/aszf'>ÁSZF</Link> és az{' '}
            <Link to='/gdpr'>Adatvédelmi Tájékoztatót</Link> elfogadom.
          </Typography>
        }
      />
      <Button
        variant='contained'
        color='primary'
        startIcon={
          <img
            src={
              theme.palette.mode === 'dark'
                ? './img/3rdparty/web_dark_rd_na.svg'
                : './img/3rdparty/web_light_rd_na.svg'
            }
            alt='Google logo'
            style={{ width: 24, height: 24 }}
          />
        }
        fullWidth
        disabled={!agree || loading}
        sx={(theme) => {
          return {
            m: 1,
            backgroundColor: '#FFFFFF',
            '&:hover': { backgroundColor: '#747775' },
            color: '#000000',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '16px',
            padding: '10px 20px',
            ...theme.applyStyles('dark', {
              color: '#FFFFFF',
              backgroundColor: '#131314',
              '&:hover': { backgroundColor: '#8E918F' },
            }),
          };
        }}
        onClick={signInWithGoogle}
      >
        Csatlakozás Google fiókkal
      </Button>
      {/*
      <Button
        variant='contained'
        color='primary'
        startIcon={
          <img
            src={'./img/3rdparty/Facebook_Logo_Primary.png'}
            alt='Facebook logo'
            style={{ width: 24, height: 24 }}
          />
        }
        fullWidth
        disabled={!agree || loading}
        sx={(theme) => {
          return {
            m: 1,
            backgroundColor: '#4267b2',
            '&:hover': { backgroundColor: '#4267b2' },

            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '16px',
            padding: '10px 20px',
            ...theme.applyStyles('dark', {
              backgroundColor: '#4267b2',
              '&:hover': { backgroundColor: '#4267b2' },
            }),
          };
        }}
        onClick={signInWithFacebook}
      >
        Csatlakozás Facebook fiókkal
      </Button>
*/}
      <Button
        //     type='submit'
        variant='contained'
        color='primary'
        fullWidth
        //     onClick={onCreateAccountClick}
        onClick={openCreateAccount}
        disabled={loading}
        sx={{ m: 1 }}
      >
        Csatlakozás E-Mail és jelszó megadásával
      </Button>
      {displayAccountData && (
        <form onSubmit={onSubmit}>
          <Paper
            elevation={3}
            sx={{ padding: 3, maxWidth: '95%', margin: '2% auto' }}
          >
            <TextField
              fullWidth
              label='Vezetéknév'
              variant='filled'
              required
              onChange={(e) => (formData.current.lastName = e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label='Keresztnév'
              variant='filled'
              required
              onChange={(e) => (formData.current.firstName = e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label='E-mail cím'
              variant='filled'
              type='email'
              required
              onChange={(e) => (formData.current.email = e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label='Jelszó'
              variant='filled'
              type='password'
              required
              onChange={(e) => (formData.current.password = e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label='Jelszó megerősítése'
              variant='filled'
              type='password'
              required
              sx={{ mb: 2 }}
            />

            <Box textAlign='center' mt={2}>
              <Button
                type='submit'
                variant='contained'
                color='primary'
                fullWidth
                disabled={!agree || loading}
              >
                {loading ? (
                  <CircularProgress size={24} />
                ) : (
                  'Új fiók létrehozása'
                )}
              </Button>
            </Box>

            <Typography variant='body2' textAlign='center' mt={2}>
              Már van fiókja? <Link to='/login'>Lépjen be</Link>
            </Typography>
          </Paper>
        </form>
      )}
      <Button
        variant='outlined'
        color='primary'
        fullWidth
        onClick={() => navigate(-1)}
        sx={{ m: 1 }}
      >
        Visszalépés
      </Button>
    </Paper>
  );
}
